<template>
  <div class="w w1200" v-loading="loading">
    <div class="section order">
      <div class="order-header">
        <div class="icon">
          <i class="el-icon-circle-check"></i>
        </div>
        <div class="order-state">
          <span class="state-text fl">订单提交成功!</span>
          <span class="amount fr">应付总额：<em class="num">{{account | decimal}}</em></span>
        </div>
        <div class="order-tips">
          <span class="tips-text fl">签收须知：签收前，请与快递员当面拆箱验货，确保货物完好。</span>
          <span class="arrow fr" @click="toggleOrderShow">
            订单详情
            <i class="el-icon-arrow-down" v-if="orderShow"></i>
            <i class="el-icon-arrow-right" v-else></i>
          </span>
        </div>
      </div>
      <div class="order-content" v-if="orderShow">
        <div class="order-info" v-for="order in orderGoodsInfo" :key="order.oid">
          <div class="order-no">订单编号：{{ order.orderNumber }}</div>
          <div class="order-address">
            收货地址：
            <span class="item">{{ order.recipient }}</span>
            <span class="item">{{ order.phoneNumber | phoneEncryption }}</span>
            <span class="item">{{ order.shipAddress }}</span>
          </div>
          <div class="order-sku">
            <label>订单商品：</label>
            <div class="sku-list">
              <div class="good" v-for="sku in order.commodityList" :key="sku.goodName">
                <span class="name">{{sku.commodityName}}</span>
                <span class="attr">{{sku.attributes}}</span>
                <span class="count">×{{sku.num}}</span>
<!--                <el-tooltip class="item" effect="dark" content="带有『易』标志的商品支持易货支付" placement="top-start">-->
<!--                  <span class="badge" v-if="sku.supportYihuo === 'Y'">易</span>-->
<!--                </el-tooltip>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section pay">
      <div class="section-title">在线支付</div>
      <el-form :model="payForm" ref="form">
      <div class="pay-ways">
        <div class="way" v-for="way in payWays" :key="way.value">
          <div class="checkbox-inner" @click="payWayChange(way)">
            <span class="checkbox-icon" :class="{'checked': way.checked}">
              <i class="el-icon-check"></i>
            </span>
            <span class="icon"><img :src="way.icon" :alt="way.value"></span>
            <span class="text">{{ way.label }}</span>
            <span class="balance" v-if="way.value === 'yhpay'">(余额：￥{{userAccount.userMoney | decimal}})</span>
          </div>
        </div>
        <el-form-item prop="balancePayAmount" label-width="110px" v-if="isMixinPay"  :rules="[
          { required: true, message: '请输入支付金额', trigger: 'blur' },
          { validator: amountValidate, trigger: 'blur' }
        ]" style="margin-bottom: 0;">
          <el-input v-model="payForm.balancePayAmount" class="amount" autocomplete="off"
                    type="number" placeholder="支付金额">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="password-box" v-if="isMixinPay">
        <div class="password-label">请输入储值宝支付密码：</div>
        <div class="password-inputer">
          <el-form-item prop="password" :rules="[
            { required: true, message: '请输入支付密码', trigger: 'blur' }
          ]">
            <el-input v-model="payForm.password" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <router-link tag="span" to="/paymentCenter" class="password-tips">忘记支付密码？</router-link>
        </div>
      </div>
    </el-form>
      <el-button type="primary" class="btn-pay" v-loading="loading" @click="doPay">立即支付</el-button>
    </div>

    <!--  微信支付二维码  -->
    <el-dialog
      title="微信扫码支付"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="handleClose">
      <div class="pay-amount">支付金额：￥{{payData.otherPay | decimal}}</div>
      <div class="wechat-qrcode" id="qrcode" v-if="dialogVisible"></div>
      <div class="btn-box">
        <el-button type="primary" @click="inquiryPayState">我已完成支付</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getUserPay,
  getBalancePayProportion,
  fetchOrderPay,
  fetchOrderPayStatus,
  fetchOrderDetailByOrderNos
} from "../../api/xunyou";
import qrcode from 'qrcodejs2';
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      orderShow: false,
      onlinePayType: 'ALIPAY_WEB',
      payWays: [
        { label: '支付宝支付', value: 'ALIPAY_WEB', icon: require('../../assets/img/alipay.png'), checked: true },
        { label: '微信支付', value: 'WECHAT_SCAN', icon: require('../../assets/img/wx.png'), checked: false },
        { label: '储值宝支付', value: 'yhpay', icon: require('../../assets/img/pay.png'), checked: false },
      ],
      userAccount: '',
      balanceRatio: 0, //余额支付比例
      qrcodeConstant: null,
      payForm: {
        balancePayAmount: null,
        password: null,
      },
      payData: '',
      repeatCount: 0,
      orderGoodsInfo: [],
      amountValidate: (rule, value, callback) => {
        if (typeof Number(value) === 'number' && !isNaN(value)) {
          if (value <= 0) {
            callback(new Error('支付金额必须大于0'));
          } else if (value > this.yhPayAmount) {
            callback(new Error(`支付金额不允许超过最大储值宝支付金额${this.yhPayAmount}元`));
          } else {
            callback();
          }
        } else {
          callback(new Error('请输入正确金额'));
        }
      }
    };
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo;
    },
    account () {
      return this.orderGoodsInfo.reduce((res, item) => {
        return res + Number(item.amount);
      }, 0);
    },
    isMixinPay () {
      let res = false;
      this.payWays.forEach(ele => {
        if (ele.value === 'yhpay' && ele.checked) {
          res = true;
        }
      });
      return res;
    },
    orderNos () {
      return this.$store.state.payOrderNos || [];
    },
    yhPayAmount () {
      let amount = 0;
      this.orderGoodsInfo.forEach(order => {
        order.commodityList.forEach(good => {
          // 仅仅支持储值的商品金额相加，然后×储值支付比例
          if (good.supportYihuo === 'Y') {
            amount += good.totalAmount;
          }
        });
      });
      return amount * this.balanceRatio / 100;
    }
  },
  created() {
    if (this.orderGoodsInfo.length && this.account === 0) {
      // 订单金额已被完全抵扣
      this.$confirm('订单当前待支付金额为0，请点击确定按钮完成订单购买流程！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
        center: true,
        closeOnClickModal: false
      }).then(() => {
        this.doPay();
      }).catch(() => {
        this.$router.replace('/myOrderRight');
      });
    }
    this.getOrderDetailByNos()
    this.getUserMoney();
  },
  methods: {
    // 根据订单号获取订单详情
    getOrderDetailByNos () {
      this.loading = true;
      fetchOrderDetailByOrderNos(this.orderNos).then(res => {
        console.log('订单详情：', res);
        this.loading = false;
        if (res.code === 0) {
          this.orderGoodsInfo = res.data;
          this.getBalancePayRules();
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        this.loading = false;
        console.error('错误：', err);
        this.$message.error('查询订单错误，请稍候重试！');
      });
    },
    // 切换显示订单信息
    toggleOrderShow () {
      this.orderShow = !this.orderShow;
    },
    // 获取储值宝支付规则
    getBalancePayRules () {
      getBalancePayProportion({ bxmId: this.orderGoodsInfo[0].bxmId }).then((res) => {
        console.log('储值宝支付规则', res);
        if (res.code === 0) {
          this.balanceRatio = Number(res.data);
        }
      }).catch((err) => {
        this.$message.error("查询余额支付比例失败，请稍后再试！");
      });
    },
    // 查询用户的有关金额
    getUserMoney() {
      getUserPay({ userId: this.userInfo.userId }).then((res) => {
        console.log('用户账户数据：', res);
        if (res.code === 0) {
          this.userAccount = res.data;
        }
      }).catch((err) => {
        this.$message.error("查询用户的有关金额失败，请稍后再试！");
      });
    },
    // 支付方式切换，储值宝支付可以和微信，支付宝支付混合
    payWayChange (way) {
      if (way.value === 'yhpay') {
        if (this.yhPayAmount <= 0) {
          this.$message.info('订单中商品不支持使用储值宝支付！');
          return false;
        }
        way.checked = !way.checked;
        if (!way.checked) {
          // 取消储值支付，清空相关金额密码信息
          this.payForm.balancePayAmount = '';
          this.payForm.password = '';
        }
        return false;
      }
      if (way.checked) return false;
      way.checked = true;
      this.onlinePayType = way.value;
      this.payWays.forEach(item => {
        if (item.value !== 'yhpay' && item.value !== way.value ) {
          item.checked = false;
        }
      });
    },
    // 立即支付
    async doPay () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            muid: this.$store.getters.userId,
            balancePay: this.payForm.balancePayAmount,
            payPassword: this.payForm.password,
            returnUrl: `${window.location.origin}/myOrderRight`,
            payChannel: this.onlinePayType,
            orderNoList: this.orderNos,
            bxmId: this.orderGoodsInfo[0].bxmId
          };
          this.loading = true;
          fetchOrderPay(params).then(res => {
            console.log('支付参数：', res);
            this.loading = false;
            if (res.code === 0) {
              this.payData = res.data;
              if (res.data.paymentStatus === 'SUCCESS') {
                // 支付完成，可能存在纯余额完全支付的情况
                this.$message.success(res.msg);
                this.$router.replace('/myOrderRight');
              } else {
                if (this.onlinePayType === 'ALIPAY_WEB') {
                  // 支付宝支付
                  this.alipayRedirect(res.data.payUrl);
                }
                if (this.onlinePayType === 'WECHAT_SCAN') {
                  // 微信支付
                  this.showWechatQrcode(res.data.payUrl);
                  // 支付二维码弹出，延迟7s后再发起支付状态轮询
                  let time = setTimeout(() => {
                    this.repeatCount = 0;
                    this.repeatFetchWechatPayState();
                    clearTimeout(time);
                  }, 7 * 1000);
                }
              }
            } else {
              this.$message.error(res.msg);
            }
          }).catch(err => {
            this.loading = false;
            console.log('错误：', err)
            this.$message.error('支付失败，请稍候重试！')
          });
        }
      });
    },
    // 支付宝支付跳转
    alipayRedirect (data) {
      const div = document.createElement('div');
      div.innerHTML = data;
      document.body.appendChild(div);
      document.forms[1].submit();
    },
    // 二维码关闭前
    handleClose (done) {
      this.qrcodeConstant = null;
      done();
    },
    // 微信支付生成二维码
    showWechatQrcode (data) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.qrcodeConstant = new qrcode('qrcode', {
          text: data,
          width: 228,
          height: 228,
          colorDark : "#000000",
          colorLight : "#ffffff"
        });
      });
    },
    // 查询订单支付状态、仅仅在微信扫码支付的时候轮询
    repeatFetchWechatPayState () {
      let timer = setTimeout(() => {
        clearTimeout(timer);
        fetchOrderPayStatus({flowNo: this.payData.payFlowNo}).then(res => {
          console.log('支付状态：', res);
          if (res.code === 0) {
            switch (res.data.payStatus) {
              case 'SUCCESS':
                this.$message.success('支付完成！');
                this.$router.replace('/myOrderRight');
                break;
              case 'FAIL':
                this.$message.success('支付失败，请稍候重试！');
                break;
              case 'PROCESS':
                // 最多查询10次
                if (this.repeatCount < 10) {
                  this.repeatCount++;
                  this.repeatFetchWechatPayState();
                }
                break;
            }
          }
        }).catch(err => {
          console.log('支付错误：', err);
          this.$message.error('订单查询失败');
        });
      }, 1000)
    },
    // 询问支付状态
    inquiryPayState () {
      fetchOrderPayStatus({flowNo: this.payData.payFlowNo})
      .then(res => {
        console.log('支付状态：', res);
        if (res.code === 0) {
          switch (res.data.payStatus) {
            case 'SUCCESS':
              this.$message.success('支付完成！');
              this.$router.replace('/myOrderRight');
              break;
            case 'FAIL':
              this.$message.error('支付失败，请稍候重试！');
              break;
            case 'PROCESS':
              this.$message.warning('未查询到支付信息');
              break;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.btn-box{
  text-align: center;
  padding-top: 10px;
}
.section{
  font-size: 14px;
  padding: 30px 60px;
  margin-top: 20px;
  background-color: #fff;
  box-sizing: border-box;
  .section-title{
    font-size: 16px;
    font-weight: 500;
    color: #777777;
  }
}
.order-header{
  height: 80px;
  padding: 10px 0;
  .icon{
    float: left;
    color: #83c44e;
    .el-icon-circle-check{
      font-size: 80px;
    }
  }
  .order-state{
    padding-top: 12px;
  }
  .order-tips{
    color: #777777;
    .arrow{
      color: #00b2ff;
      cursor: pointer;
    }
  }
  .order-state, .order-tips{
    padding-left: 10px;
    overflow: hidden;
  }
  .state-text{
    font-size: 24px;
    font-weight: 500;
  }
  .num{
    color: var(--main-theme-color);
    font-size: 24px;
    &:before{
      content: '￥';
      font-size: 14px;
    }
  }
}
.order-content{
    padding: 10px 20px;
    border-radius: 0 0 5px 5px;
    background-color: #F5F5F5;
    border-top: 1px solid #dcdfe6;
    .order-info{
      border-bottom: 1px solid #dcdfe6;
      padding: 10px 0;
      &:last-child{
        border-width: 0;
      }
    }
    .order-sku{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .badge{
        display: inline-block;
        color: var(--main-theme-color);
        background-color: #fff;
        border-radius: 3px;
        padding: 0 4px;
        border: 1px solid var(--main-theme-color);
        cursor: pointer;
        transform: scale(0.7);
      }
    }
  }

.pay-ways{
  padding: 30px 0;
  box-shadow: 0px 0px 2px rgba(111,111,111,0.2);
  border-radius: 5px;
  margin-top: 15px;
  .way{
    padding:0 20px;
    margin-bottom: 20px;
    cursor: pointer;
    &:last-child{
      margin-bottom: 0;
    }
  }
  .amount{
    width: 200px;
  }
}
.checkbox-inner{
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  .checkbox-icon{
    width: 20px;
    height: 20px;
    color: #ffffff;
    text-align: center;
    line-height: 22px;
    margin-right: 15px;
    border-radius: 4px;
    border:1px solid #cccccc;
    /deep/ .el-icon-check{
      font-weight: bold;
    }
    &.checked{
      background-color: #409eff;
      border-color: #409eff;
    }
  }
  .text{
    font-size: 18px;
    font-weight: 500;
    color: #333333;
  }
  .icon{
    display: inline-block;
    width: 40px;
    height: 40px;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.password-box{
  padding: 10px 20px;
  .password-label{
    color: #999999;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .password-inputer{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/ .el-input{
      width: 220px;
    }
    .password-tips{
      margin-left: 10px;
      color: #0c80dc;
      font-size: 12px;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
  }
}
.btn-pay{
  width: 220px;
  margin-left: 20px;
  margin-top: 20px;
  background-color: var(--main-theme-color);
  border-color: var(--main-theme-color);
}
.pay-amount{
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}
.wechat-qrcode{
  width: 228px;
  height: 228px;
  border-radius: 5px;
  margin: 0 auto;
  background-color: #f5f5f5;
  overflow: hidden;
  border: 2px solid #333333;
}
</style>







// WEBPACK FOOTER //
// src/views/shoppingcart/orderNow.vue